import React, { useContext } from "react";
import classes from "./Header.module.css";
import { useTranslation } from "react-i18next";
import { MENU_HEADER, NAIL_SHOP_INFO } from "../../utils/Const";
import { images } from "../../assets/img";
import { t } from "../../locales/i18n";
import BookNowBtn from "../BookNowBtn";
import { useNavigate } from "react-router-dom";
import useCheckIsMobile from "../../hook/useCheckIsMobile";
import Menu from "../Menu/Menu";
import { menuHeaderHandler } from "../../navigation/MenuHeaderHandler";
import AuthContext from "../../store/auth-context";

const Header = (props) => {
  const {
    introductionRef,
    contactsRef,
    serviceRef,
    onPressMainLogo,
    selected,
  } = props || {};
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useCheckIsMobile();
  const { selectedBranch } = useContext(AuthContext);

  const renderLogo = () => {
    return (
      <img
        onClick={onPressMainLogo}
        className={`${classes.introLogo} ${
          onPressMainLogo ? classes.clickableLogo : null
        }`}
        alt={"main logo"}
        src={images.main_logo}
      />
    );
  };

  return (
    <div className={classes.introHeader}>
      <img
        className={classes.headerBannerImg}
        alt={"Primary Banner"}
        src={images.header_primary02}
        loading="eager"
        decoding="async"
        fetchPriority="high"
      />

      {/* {!isMobile && renderLogo()} */}

      <div className={classes.headerIntroContainer}>
        <h2>{isMobile ? NAIL_SHOP_INFO.name : "Kevin Nails"}</h2>
        <h3>
          {selectedBranch?.headerWelcomeMsg?.replace(
            "$lineBreak",
            isMobile ? " " : "\n"
          )}
        </h3>
      </div>

      {isMobile ? (
        <Menu
          selected={selected}
          introductionRef={introductionRef}
          serviceRef={serviceRef}
          contactsRef={contactsRef}
        />
      ) : (
        <div className={classes.menuItem}>
          {MENU_HEADER.map((item, index) => {
            const { name, navigationKey } = item || {};
            return (
              <h4
                key={`${name}_${index}`}
                onClick={() => menuHeaderHandler(navigationKey, navigate)}
                className={
                  selected === navigationKey ? classes.selectedText : ""
                }
              >
                {name}
              </h4>
            );
          })}

        </div>
      )}

    </div>
  );
};

export default Header;
